module.exports = __webpack_public_path__ + "img/位图30.d7ec5c53.png";